// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../types';
import media from '../../../../helpers/media';
import { GroupTitleStyled } from '../groupTitle/groupTitle.styled';
import Model from './model';

type Props = {
  boxed: ?boolean,
};

export default styled<typeof Model, Theme, Props>(Model)`
  ${props => props.boxed && css`
    &:first-child {
      margin-top: 0;

      ${GroupTitleStyled} { /* stylelint-disable-line */
        padding-top: 0;
      }

      ${media.lg(css`
        margin-top: 1rem;

        ${GroupTitleStyled} { /* stylelint-disable-line */
          padding-top: .75rem;
        }
      `)}
    }
  `}
`;
